var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"98%","background":"#fff","width":"98%","margin":"10px auto"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"img"},[_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setC5One: _vm.setC5One,
				getC5One: _vm.getC5One,
				setC5Two: _vm.setC5Two,
				getC5Two: _vm.getC5Two,
				setPj: _vm.setPj,
				getPj: _vm.getPj,
				setC6: _vm.setC6,
				getC6: _vm.getC6,
				setduoBi: _vm.setduoBi,
				getduoBi: _vm.getduoBi,
				setButtom: _vm.setButtom,
				getButtom: _vm.getButtom,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setC4: _vm.setC4,
				getC4: _vm.getC4,
				setC3: _vm.setC3,
				getC3: _vm.getC3,
				setC1: _vm.setC1,
				getC1: _vm.getC1,
				setCurtains: _vm.setCurtains,
				getCurtains: _vm.getCurtains,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetC5One,\n\t\t\t\tgetC5One,\n\t\t\t\tsetC5Two,\n\t\t\t\tgetC5Two,\n\t\t\t\tsetPj,\n\t\t\t\tgetPj,\n\t\t\t\tsetC6,\n\t\t\t\tgetC6,\n\t\t\t\tsetduoBi,\n\t\t\t\tgetduoBi,\n\t\t\t\tsetButtom,\n\t\t\t\tgetButtom,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetC4,\n\t\t\t\tgetC4,\n\t\t\t\tsetC3,\n\t\t\t\tgetC3,\n\t\t\t\tsetC1,\n\t\t\t\tgetC1,\n\t\t\t\tsetCurtains,\n\t\t\t\tgetCurtains,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"C1"}},[_c('img',{attrs:{"src":require("../assets/img/curtains/c1.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setC5One: _vm.setC5One,
				getC5One: _vm.getC5One,
				setC5Two: _vm.setC5Two,
				getC5Two: _vm.getC5Two,
				setPj: _vm.setPj,
				getPj: _vm.getPj,
				setC6: _vm.setC6,
				getC6: _vm.getC6,
				setduoBi: _vm.setduoBi,
				getduoBi: _vm.getduoBi,
				setButtom: _vm.setButtom,
				getButtom: _vm.getButtom,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setC4: _vm.setC4,
				getC4: _vm.getC4,
				setC3: _vm.setC3,
				getC3: _vm.getC3,
				setC1: _vm.setC1,
				getC1: _vm.getC1,
				setCurtains: _vm.setCurtains,
				getCurtains: _vm.getCurtains,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetC5One,\n\t\t\t\tgetC5One,\n\t\t\t\tsetC5Two,\n\t\t\t\tgetC5Two,\n\t\t\t\tsetPj,\n\t\t\t\tgetPj,\n\t\t\t\tsetC6,\n\t\t\t\tgetC6,\n\t\t\t\tsetduoBi,\n\t\t\t\tgetduoBi,\n\t\t\t\tsetButtom,\n\t\t\t\tgetButtom,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetC4,\n\t\t\t\tgetC4,\n\t\t\t\tsetC3,\n\t\t\t\tgetC3,\n\t\t\t\tsetC1,\n\t\t\t\tgetC1,\n\t\t\t\tsetCurtains,\n\t\t\t\tgetCurtains,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"curtains"}},[_c('img',{attrs:{"src":require("../assets/img/curtains/Curtains.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setC5One: _vm.setC5One,
				getC5One: _vm.getC5One,
				setC5Two: _vm.setC5Two,
				getC5Two: _vm.getC5Two,
				setPj: _vm.setPj,
				getPj: _vm.getPj,
				setC6: _vm.setC6,
				getC6: _vm.getC6,
				setduoBi: _vm.setduoBi,
				getduoBi: _vm.getduoBi,
				setButtom: _vm.setButtom,
				getButtom: _vm.getButtom,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setC4: _vm.setC4,
				getC4: _vm.getC4,
				setC3: _vm.setC3,
				getC3: _vm.getC3,
				setC1: _vm.setC1,
				getC1: _vm.getC1,
				setCurtains: _vm.setCurtains,
				getCurtains: _vm.getCurtains,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetC5One,\n\t\t\t\tgetC5One,\n\t\t\t\tsetC5Two,\n\t\t\t\tgetC5Two,\n\t\t\t\tsetPj,\n\t\t\t\tgetPj,\n\t\t\t\tsetC6,\n\t\t\t\tgetC6,\n\t\t\t\tsetduoBi,\n\t\t\t\tgetduoBi,\n\t\t\t\tsetButtom,\n\t\t\t\tgetButtom,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetC4,\n\t\t\t\tgetC4,\n\t\t\t\tsetC3,\n\t\t\t\tgetC3,\n\t\t\t\tsetC1,\n\t\t\t\tgetC1,\n\t\t\t\tsetCurtains,\n\t\t\t\tgetCurtains,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"C2"}},[_c('img',{attrs:{"src":require("../assets/img/curtains/c2.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setC5One: _vm.setC5One,
				getC5One: _vm.getC5One,
				setC5Two: _vm.setC5Two,
				getC5Two: _vm.getC5Two,
				setPj: _vm.setPj,
				getPj: _vm.getPj,
				setC6: _vm.setC6,
				getC6: _vm.getC6,
				setduoBi: _vm.setduoBi,
				getduoBi: _vm.getduoBi,
				setButtom: _vm.setButtom,
				getButtom: _vm.getButtom,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setC4: _vm.setC4,
				getC4: _vm.getC4,
				setC3: _vm.setC3,
				getC3: _vm.getC3,
				setC1: _vm.setC1,
				getC1: _vm.getC1,
				setCurtains: _vm.setCurtains,
				getCurtains: _vm.getCurtains,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetC5One,\n\t\t\t\tgetC5One,\n\t\t\t\tsetC5Two,\n\t\t\t\tgetC5Two,\n\t\t\t\tsetPj,\n\t\t\t\tgetPj,\n\t\t\t\tsetC6,\n\t\t\t\tgetC6,\n\t\t\t\tsetduoBi,\n\t\t\t\tgetduoBi,\n\t\t\t\tsetButtom,\n\t\t\t\tgetButtom,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetC4,\n\t\t\t\tgetC4,\n\t\t\t\tsetC3,\n\t\t\t\tgetC3,\n\t\t\t\tsetC1,\n\t\t\t\tgetC1,\n\t\t\t\tsetCurtains,\n\t\t\t\tgetCurtains,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"C5One"}},[_c('img',{attrs:{"src":require("../assets/img/curtains/c5One.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setC5One: _vm.setC5One,
				getC5One: _vm.getC5One,
				setC5Two: _vm.setC5Two,
				getC5Two: _vm.getC5Two,
				setPj: _vm.setPj,
				getPj: _vm.getPj,
				setC6: _vm.setC6,
				getC6: _vm.getC6,
				setduoBi: _vm.setduoBi,
				getduoBi: _vm.getduoBi,
				setButtom: _vm.setButtom,
				getButtom: _vm.getButtom,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setC4: _vm.setC4,
				getC4: _vm.getC4,
				setC3: _vm.setC3,
				getC3: _vm.getC3,
				setC1: _vm.setC1,
				getC1: _vm.getC1,
				setCurtains: _vm.setCurtains,
				getCurtains: _vm.getCurtains,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetC5One,\n\t\t\t\tgetC5One,\n\t\t\t\tsetC5Two,\n\t\t\t\tgetC5Two,\n\t\t\t\tsetPj,\n\t\t\t\tgetPj,\n\t\t\t\tsetC6,\n\t\t\t\tgetC6,\n\t\t\t\tsetduoBi,\n\t\t\t\tgetduoBi,\n\t\t\t\tsetButtom,\n\t\t\t\tgetButtom,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetC4,\n\t\t\t\tgetC4,\n\t\t\t\tsetC3,\n\t\t\t\tgetC3,\n\t\t\t\tsetC1,\n\t\t\t\tgetC1,\n\t\t\t\tsetCurtains,\n\t\t\t\tgetCurtains,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"C5Two"}},[_c('img',{attrs:{"src":require("../assets/img/curtains/c5Two.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setC5One: _vm.setC5One,
				getC5One: _vm.getC5One,
				setC5Two: _vm.setC5Two,
				getC5Two: _vm.getC5Two,
				setPj: _vm.setPj,
				getPj: _vm.getPj,
				setC6: _vm.setC6,
				getC6: _vm.getC6,
				setduoBi: _vm.setduoBi,
				getduoBi: _vm.getduoBi,
				setButtom: _vm.setButtom,
				getButtom: _vm.getButtom,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setC4: _vm.setC4,
				getC4: _vm.getC4,
				setC3: _vm.setC3,
				getC3: _vm.getC3,
				setC1: _vm.setC1,
				getC1: _vm.getC1,
				setCurtains: _vm.setCurtains,
				getCurtains: _vm.getCurtains,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetC5One,\n\t\t\t\tgetC5One,\n\t\t\t\tsetC5Two,\n\t\t\t\tgetC5Two,\n\t\t\t\tsetPj,\n\t\t\t\tgetPj,\n\t\t\t\tsetC6,\n\t\t\t\tgetC6,\n\t\t\t\tsetduoBi,\n\t\t\t\tgetduoBi,\n\t\t\t\tsetButtom,\n\t\t\t\tgetButtom,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetC4,\n\t\t\t\tgetC4,\n\t\t\t\tsetC3,\n\t\t\t\tgetC3,\n\t\t\t\tsetC1,\n\t\t\t\tgetC1,\n\t\t\t\tsetCurtains,\n\t\t\t\tgetCurtains,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"line"}},[_c('img',{attrs:{"src":require("../assets/img/curtains/line.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setC5One: _vm.setC5One,
				getC5One: _vm.getC5One,
				setC5Two: _vm.setC5Two,
				getC5Two: _vm.getC5Two,
				setPj: _vm.setPj,
				getPj: _vm.getPj,
				setC6: _vm.setC6,
				getC6: _vm.getC6,
				setduoBi: _vm.setduoBi,
				getduoBi: _vm.getduoBi,
				setButtom: _vm.setButtom,
				getButtom: _vm.getButtom,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setC4: _vm.setC4,
				getC4: _vm.getC4,
				setC3: _vm.setC3,
				getC3: _vm.getC3,
				setC1: _vm.setC1,
				getC1: _vm.getC1,
				setCurtains: _vm.setCurtains,
				getCurtains: _vm.getCurtains,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetC5One,\n\t\t\t\tgetC5One,\n\t\t\t\tsetC5Two,\n\t\t\t\tgetC5Two,\n\t\t\t\tsetPj,\n\t\t\t\tgetPj,\n\t\t\t\tsetC6,\n\t\t\t\tgetC6,\n\t\t\t\tsetduoBi,\n\t\t\t\tgetduoBi,\n\t\t\t\tsetButtom,\n\t\t\t\tgetButtom,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetC4,\n\t\t\t\tgetC4,\n\t\t\t\tsetC3,\n\t\t\t\tgetC3,\n\t\t\t\tsetC1,\n\t\t\t\tgetC1,\n\t\t\t\tsetCurtains,\n\t\t\t\tgetCurtains,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"duobi"}},[_c('img',{attrs:{"src":require("../assets/img/curtains/duobi.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setC5One: _vm.setC5One,
				getC5One: _vm.getC5One,
				setC5Two: _vm.setC5Two,
				getC5Two: _vm.getC5Two,
				setPj: _vm.setPj,
				getPj: _vm.getPj,
				setC6: _vm.setC6,
				getC6: _vm.getC6,
				setduoBi: _vm.setduoBi,
				getduoBi: _vm.getduoBi,
				setButtom: _vm.setButtom,
				getButtom: _vm.getButtom,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setC4: _vm.setC4,
				getC4: _vm.getC4,
				setC3: _vm.setC3,
				getC3: _vm.getC3,
				setC1: _vm.setC1,
				getC1: _vm.getC1,
				setCurtains: _vm.setCurtains,
				getCurtains: _vm.getCurtains,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetC5One,\n\t\t\t\tgetC5One,\n\t\t\t\tsetC5Two,\n\t\t\t\tgetC5Two,\n\t\t\t\tsetPj,\n\t\t\t\tgetPj,\n\t\t\t\tsetC6,\n\t\t\t\tgetC6,\n\t\t\t\tsetduoBi,\n\t\t\t\tgetduoBi,\n\t\t\t\tsetButtom,\n\t\t\t\tgetButtom,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetC4,\n\t\t\t\tgetC4,\n\t\t\t\tsetC3,\n\t\t\t\tgetC3,\n\t\t\t\tsetC1,\n\t\t\t\tgetC1,\n\t\t\t\tsetCurtains,\n\t\t\t\tgetCurtains,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"C3"}},[_c('img',{attrs:{"src":require("../assets/img/curtains/c3.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setC5One: _vm.setC5One,
				getC5One: _vm.getC5One,
				setC5Two: _vm.setC5Two,
				getC5Two: _vm.getC5Two,
				setPj: _vm.setPj,
				getPj: _vm.getPj,
				setC6: _vm.setC6,
				getC6: _vm.getC6,
				setduoBi: _vm.setduoBi,
				getduoBi: _vm.getduoBi,
				setButtom: _vm.setButtom,
				getButtom: _vm.getButtom,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setC4: _vm.setC4,
				getC4: _vm.getC4,
				setC3: _vm.setC3,
				getC3: _vm.getC3,
				setC1: _vm.setC1,
				getC1: _vm.getC1,
				setCurtains: _vm.setCurtains,
				getCurtains: _vm.getCurtains,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetC5One,\n\t\t\t\tgetC5One,\n\t\t\t\tsetC5Two,\n\t\t\t\tgetC5Two,\n\t\t\t\tsetPj,\n\t\t\t\tgetPj,\n\t\t\t\tsetC6,\n\t\t\t\tgetC6,\n\t\t\t\tsetduoBi,\n\t\t\t\tgetduoBi,\n\t\t\t\tsetButtom,\n\t\t\t\tgetButtom,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetC4,\n\t\t\t\tgetC4,\n\t\t\t\tsetC3,\n\t\t\t\tgetC3,\n\t\t\t\tsetC1,\n\t\t\t\tgetC1,\n\t\t\t\tsetCurtains,\n\t\t\t\tgetCurtains,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"pj"}},[_c('img',{attrs:{"src":require("../assets/img/curtains/pj.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setC5One: _vm.setC5One,
				getC5One: _vm.getC5One,
				setC5Two: _vm.setC5Two,
				getC5Two: _vm.getC5Two,
				setPj: _vm.setPj,
				getPj: _vm.getPj,
				setC6: _vm.setC6,
				getC6: _vm.getC6,
				setduoBi: _vm.setduoBi,
				getduoBi: _vm.getduoBi,
				setButtom: _vm.setButtom,
				getButtom: _vm.getButtom,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setC4: _vm.setC4,
				getC4: _vm.getC4,
				setC3: _vm.setC3,
				getC3: _vm.getC3,
				setC1: _vm.setC1,
				getC1: _vm.getC1,
				setCurtains: _vm.setCurtains,
				getCurtains: _vm.getCurtains,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetC5One,\n\t\t\t\tgetC5One,\n\t\t\t\tsetC5Two,\n\t\t\t\tgetC5Two,\n\t\t\t\tsetPj,\n\t\t\t\tgetPj,\n\t\t\t\tsetC6,\n\t\t\t\tgetC6,\n\t\t\t\tsetduoBi,\n\t\t\t\tgetduoBi,\n\t\t\t\tsetButtom,\n\t\t\t\tgetButtom,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetC4,\n\t\t\t\tgetC4,\n\t\t\t\tsetC3,\n\t\t\t\tgetC3,\n\t\t\t\tsetC1,\n\t\t\t\tgetC1,\n\t\t\t\tsetCurtains,\n\t\t\t\tgetCurtains,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"C6"}},[_c('img',{attrs:{"src":require("../assets/img/curtains/c6.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setC5One: _vm.setC5One,
				getC5One: _vm.getC5One,
				setC5Two: _vm.setC5Two,
				getC5Two: _vm.getC5Two,
				setPj: _vm.setPj,
				getPj: _vm.getPj,
				setC6: _vm.setC6,
				getC6: _vm.getC6,
				setduoBi: _vm.setduoBi,
				getduoBi: _vm.getduoBi,
				setButtom: _vm.setButtom,
				getButtom: _vm.getButtom,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setC4: _vm.setC4,
				getC4: _vm.getC4,
				setC3: _vm.setC3,
				getC3: _vm.getC3,
				setC1: _vm.setC1,
				getC1: _vm.getC1,
				setCurtains: _vm.setCurtains,
				getCurtains: _vm.getCurtains,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetC5One,\n\t\t\t\tgetC5One,\n\t\t\t\tsetC5Two,\n\t\t\t\tgetC5Two,\n\t\t\t\tsetPj,\n\t\t\t\tgetPj,\n\t\t\t\tsetC6,\n\t\t\t\tgetC6,\n\t\t\t\tsetduoBi,\n\t\t\t\tgetduoBi,\n\t\t\t\tsetButtom,\n\t\t\t\tgetButtom,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetC4,\n\t\t\t\tgetC4,\n\t\t\t\tsetC3,\n\t\t\t\tgetC3,\n\t\t\t\tsetC1,\n\t\t\t\tgetC1,\n\t\t\t\tsetCurtains,\n\t\t\t\tgetCurtains,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"C4"}},[_c('img',{attrs:{"src":require("../assets/img/curtains/c4.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setC5One: _vm.setC5One,
				getC5One: _vm.getC5One,
				setC5Two: _vm.setC5Two,
				getC5Two: _vm.getC5Two,
				setPj: _vm.setPj,
				getPj: _vm.getPj,
				setC6: _vm.setC6,
				getC6: _vm.getC6,
				setduoBi: _vm.setduoBi,
				getduoBi: _vm.getduoBi,
				setButtom: _vm.setButtom,
				getButtom: _vm.getButtom,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setC4: _vm.setC4,
				getC4: _vm.getC4,
				setC3: _vm.setC3,
				getC3: _vm.getC3,
				setC1: _vm.setC1,
				getC1: _vm.getC1,
				setCurtains: _vm.setCurtains,
				getCurtains: _vm.getCurtains,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetC5One,\n\t\t\t\tgetC5One,\n\t\t\t\tsetC5Two,\n\t\t\t\tgetC5Two,\n\t\t\t\tsetPj,\n\t\t\t\tgetPj,\n\t\t\t\tsetC6,\n\t\t\t\tgetC6,\n\t\t\t\tsetduoBi,\n\t\t\t\tgetduoBi,\n\t\t\t\tsetButtom,\n\t\t\t\tgetButtom,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetC4,\n\t\t\t\tgetC4,\n\t\t\t\tsetC3,\n\t\t\t\tgetC3,\n\t\t\t\tsetC1,\n\t\t\t\tgetC1,\n\t\t\t\tsetCurtains,\n\t\t\t\tgetCurtains,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"screan"}},[_c('img',{attrs:{"src":require("../assets/img/light/screan.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setC5One: _vm.setC5One,
				getC5One: _vm.getC5One,
				setC5Two: _vm.setC5Two,
				getC5Two: _vm.getC5Two,
				setPj: _vm.setPj,
				getPj: _vm.getPj,
				setC6: _vm.setC6,
				getC6: _vm.getC6,
				setduoBi: _vm.setduoBi,
				getduoBi: _vm.getduoBi,
				setButtom: _vm.setButtom,
				getButtom: _vm.getButtom,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setC4: _vm.setC4,
				getC4: _vm.getC4,
				setC3: _vm.setC3,
				getC3: _vm.getC3,
				setC1: _vm.setC1,
				getC1: _vm.getC1,
				setCurtains: _vm.setCurtains,
				getCurtains: _vm.getCurtains,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetC5One,\n\t\t\t\tgetC5One,\n\t\t\t\tsetC5Two,\n\t\t\t\tgetC5Two,\n\t\t\t\tsetPj,\n\t\t\t\tgetPj,\n\t\t\t\tsetC6,\n\t\t\t\tgetC6,\n\t\t\t\tsetduoBi,\n\t\t\t\tgetduoBi,\n\t\t\t\tsetButtom,\n\t\t\t\tgetButtom,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetC4,\n\t\t\t\tgetC4,\n\t\t\t\tsetC3,\n\t\t\t\tgetC3,\n\t\t\t\tsetC1,\n\t\t\t\tgetC1,\n\t\t\t\tsetCurtains,\n\t\t\t\tgetCurtains,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"bottom"}},[_c('img',{attrs:{"src":require("../assets/img/door/bottom.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setC5One: _vm.setC5One,
				getC5One: _vm.getC5One,
				setC5Two: _vm.setC5Two,
				getC5Two: _vm.getC5Two,
				setPj: _vm.setPj,
				getPj: _vm.getPj,
				setC6: _vm.setC6,
				getC6: _vm.getC6,
				setduoBi: _vm.setduoBi,
				getduoBi: _vm.getduoBi,
				setButtom: _vm.setButtom,
				getButtom: _vm.getButtom,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setC4: _vm.setC4,
				getC4: _vm.getC4,
				setC3: _vm.setC3,
				getC3: _vm.getC3,
				setC1: _vm.setC1,
				getC1: _vm.getC1,
				setCurtains: _vm.setCurtains,
				getCurtains: _vm.getCurtains,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetC5One,\n\t\t\t\tgetC5One,\n\t\t\t\tsetC5Two,\n\t\t\t\tgetC5Two,\n\t\t\t\tsetPj,\n\t\t\t\tgetPj,\n\t\t\t\tsetC6,\n\t\t\t\tgetC6,\n\t\t\t\tsetduoBi,\n\t\t\t\tgetduoBi,\n\t\t\t\tsetButtom,\n\t\t\t\tgetButtom,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetC4,\n\t\t\t\tgetC4,\n\t\t\t\tsetC3,\n\t\t\t\tgetC3,\n\t\t\t\tsetC1,\n\t\t\t\tgetC1,\n\t\t\t\tsetCurtains,\n\t\t\t\tgetCurtains,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"ai"}},[_c('img',{attrs:{"src":require("../assets/img/ai.png"),"alt":""}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"button"},[_vm._v("进入CocoBlockly编程平台")]),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"musicC","src":require('../assets/music/click.mp3')}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip"},[_c('img',{attrs:{"src":require("../assets/img/curtains/tips.png"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},[_c('img',{attrs:{"src":require("../assets/img/right.png"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08f38c5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/curtain.vue
// module id = null
// module chunks = 